import { Pipe, PipeTransform } from '@angular/core';
import { ColumnDefinition } from '../advanced-gridview/models/column-definition';
import { ColumnListDefinition } from '../advanced-gridview/models/column-list-definition';
import { ColumnType } from '../advanced-gridview/models/column-type';

@Pipe({
    name: 'avmFilterSubstring',
    standalone: true,
})
export class AvmFilterSubstringPipe implements PipeTransform {
    transform(columnDefinition: ColumnDefinition, values: any, maxChars: number = 10): string {
        let result: string = '';

        if (columnDefinition.type === ColumnType.List || columnDefinition.type === ColumnType.MultipleList) {
            if (values) {
                let columnListDefinition = columnDefinition as ColumnListDefinition<string>;

                (values as string[]).forEach((x) => {
                    result += columnListDefinition.dataSource.get(x).text + ',';
                });
            }

            result = result.substring(0, result.length - 1);
        } else {
            if (values) {
                result = values as string;
            }
        }

        return this.substringResultValue(result, maxChars);
    }

    private substringResultValue(resultValue: string, maxChars: number): string {
        if (resultValue.length > maxChars) {
            return resultValue.substring(0, maxChars - 3) + '...';
        } else {
            return resultValue;
        }
    }
}
